import { render, staticRenderFns } from "./orderXq.vue?vue&type=template&id=d5e06776&scoped=true&"
import script from "./orderXq.vue?vue&type=script&lang=js&"
export * from "./orderXq.vue?vue&type=script&lang=js&"
import style0 from "./orderXq.vue?vue&type=style&index=0&id=d5e06776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e06776",
  null
  
)

export default component.exports